import React from "react";
import { COUPON_PREVIEW_NOT_SET } from "constants/coupons";
import {
  formatAmountWithCurrencyPrefix,
  getCurrencyBlockTitle,
  getCurrencyCode,
  isFlatDiscount,
  isPercentageDiscount,
} from "helpers/couponDiscountType";

import CouponFormFieldLabel from "./CouponFormFieldLabel";
import styles from "../CouponForm.module.scss";

const CurrencyAmountBlock = ({
  currencyId,
  currencyOptions,
  settings,
  fieldErrors = {},
  isView,
  discountType,
  lockDiscountAmount = false,
  renderFieldInput,
  renderAmountDecimalHint,
  updateCurrencySettingField,
}) => {
  const currencyCode = getCurrencyCode(currencyOptions, currencyId);
  const currencyLabel =
    getCurrencyBlockTitle(currencyOptions, currencyId) ||
    `Currency ${currencyId}`;
  const isFlat = isFlatDiscount(discountType);
  const isPercentage = isPercentageDiscount(discountType);

  const renderAmountField = ({
    fieldName,
    label,
    required = true,
    optional = false,
    locked = false,
  }) => {
    const value = settings?.[fieldName] ?? "";
    const fieldLabel = currencyCode ? `${label} (${currencyCode})` : label;
    const isLocked = isView || locked;

    return (
      <div className={styles.fieldGroup}>
        <CouponFormFieldLabel required={required} optional={optional}>
          {fieldLabel}
        </CouponFormFieldLabel>
        {isLocked ? (
          renderFieldInput(
            fieldName,
            <span>
              {value === "" || value === null || value === undefined
                ? optional
                  ? "—"
                  : COUPON_PREVIEW_NOT_SET
                : formatAmountWithCurrencyPrefix(
                    value,
                    currencyOptions,
                    currencyId
                  )}
            </span>,
            true
          )
        ) : (
          renderFieldInput(
            fieldName,
            <input
              type="text"
              inputMode="decimal"
              placeholder={
                currencyCode
                  ? `Enter amount in ${currencyCode}`
                  : "Enter amount"
              }
              value={value}
              onChange={(event) =>
                updateCurrencySettingField(
                  currencyId,
                  fieldName,
                  event.target.value
                )
              }
            />
          )
        )}
        {fieldErrors[fieldName] ? (
          <p className={styles.fieldError}>{fieldErrors[fieldName]}</p>
        ) : null}
        {!isLocked && renderAmountDecimalHint()}
      </div>
    );
  };

  return (
    <div className={styles.currencyEligibilityBlock}>
      <div className={styles.currencyEligibilityHeader}>{currencyLabel}</div>
      <div className={styles.fieldGrid}>
        {isFlat
          ? renderAmountField({
              fieldName: "discountAmount",
              label: "Flat Discount Amount",
              locked: lockDiscountAmount,
            })
          : null}
        {isPercentage
          ? renderAmountField({
              fieldName: "maxAllowedAmount",
              label: "Max Allowed Discount Amount",
            })
          : null}
        {renderAmountField({
          fieldName: "minimumPackageMrp",
          label: "Minimum Package MRP",
        })}
        {renderAmountField({
          fieldName: "minimumCartMrp",
          label: "Minimum Cart MRP",
          required: false,
          optional: true,
        })}
      </div>
    </div>
  );
};

export default CurrencyAmountBlock;
